import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const VisibilitySVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default VisibilitySVG;
